


























































































import { Component, Vue } from 'vue-property-decorator';
import { emailApis, AppPassword } from '@/api/email.api';

@Component
export default class MailAppPasswordPage extends Vue {
  appPasswords: AppPassword[] = [];
  loading = false;
  createDialogVisible = false;
  passwordDialogVisible = false;
  creating = false;
  generatedPassword = '';

  createForm = {
    remark: '',
    expires_in_days: 365
  };

  createRules = {
    remark: [{ required: true, message: '请输入备注信息', trigger: 'blur' }],
    expires_in_days: [{ required: true, message: '请选择有效期', trigger: 'change' }]
  };

  created() {
    this.loadAppPasswords();
  }

  async loadAppPasswords() {
    this.loading = true;
    try {
      const result = await emailApis.listAppPasswords();
      this.appPasswords = result.items;
    } catch (error) {
      this.$message.error('加载客户端密码列表失败');
      console.error(error);
    } finally {
      this.loading = false;
    }
  }

  showCreateDialog() {
    this.createForm = {
      remark: '',
      expires_in_days: 365
    };
    this.createDialogVisible = true;
  }

  // 生成随机密码字符串
  generateRandomPassword(length?: number): string {
    length = length || 24;
    const charset = 'ABCDEFGHIJKMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz0123456789!@#';
    let password = '';
    const array = new Uint8Array(length);
    crypto.getRandomValues(array);
    for (let i = 0; i < length; i++) {
      password += charset[array[i] % charset.length];
    }
    return password;
  }

  async handleCreate() {
    const form = this.$refs.createForm as any;
    form.validate(async (valid: boolean) => {
      if (!valid) return;

      this.creating = true;
      try {
        // 前端生成随机密码, 长度16-24随机
        const length = Math.floor(Math.random() * (24 - 16 + 1)) + 16;
        const plainPassword = this.generateRandomPassword(length);

        await emailApis.createAppPassword(this.createForm.remark, this.createForm.expires_in_days, plainPassword);

        this.$message.success('客户端密码创建成功');
        this.createDialogVisible = false;

        // 显示生成的密码
        this.generatedPassword = plainPassword;
        this.passwordDialogVisible = true;

        // 重新加载列表
        this.loadAppPasswords();
      } catch (error) {
        this.$message.error(`创建客户端密码失败: ${error}`);
        console.error(error);
      } finally {
        this.creating = false;
      }
    });
  }

  handleDelete(row: AppPassword) {
    this.$confirm(`确定要删除备注为"${row.remark}"的客户端密码吗？删除后将无法恢复！`, '删除确认', {
      confirmButtonText: '确定删除',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(async () => {
        try {
          await emailApis.deleteAppPassword(row.id);
          this.$message.success('删除成功');
          this.loadAppPasswords();
        } catch (error) {
          this.$message.error('删除失败');
          console.error(error);
        }
      })
      .catch(() => {
        // 用户取消
      });
  }

  copyPassword() {
    const textarea = document.createElement('textarea');
    textarea.value = this.generatedPassword;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();

    try {
      document.execCommand('copy');
      this.$message.success('密码已复制到剪贴板');
    } catch (err) {
      this.$message.error('复制失败，请手动复制');
    } finally {
      document.body.removeChild(textarea);
    }
  }

  closePasswordDialog() {
    this.passwordDialogVisible = false;
    this.generatedPassword = '';
  }

  formatDate(dateStr: string): string {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return date.toLocaleString('zh-CN', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  }
}
